// Match the display-symbol normalization used by the Screener add endpoint.
export function normalizeScreenerTicker(symbol: string): string {
  const normalized = symbol.trim().toUpperCase().replace(/[/_\s-]/g, '')
  // USDC and BUSD can be base assets as well as terminal quote currencies.
  if (normalized === 'USDC' || normalized === 'BUSD') return normalized
  // A colon separates a HIP-3 namespace from its asset. Only remove it when
  // it is a quote delimiter, as in BTC:USDT or XYZ:EWY:USDT.
  return normalized.replace(/:?(?:USDT|USDC|BUSD|USD|PERP)$/, '')
}

const PASTE_STOPWORDS = new Set([
  'BINANCE', 'BYBIT', 'OKX', 'GATE', 'BITGET', 'MEXC', 'KUCOIN',
  'SPOT', 'FUTURES', 'PERPETUAL', 'MARK', 'PRICE',
  'HTTP', 'HTTPS', 'WWW', 'COM',
  'USDT', 'USD',
])

export function extractTickerFromPastedText(raw: string): string | null {
  const upper = (raw || '').toUpperCase()
  if (!upper.trim()) return null

  // Match the complete namespaced instrument before searching for plain
  // pairs or words, which would otherwise turn XYZ:EWYUSDT into EWYUSDT.
  const namespaced = upper.matchAll(/\b([A-Z0-9]{1,15}):([A-Z0-9]{1,30}(?:[/_:-](?:USDT|USDC|BUSD|USD|PERP))?)\b/g)
  for (const match of namespaced) {
    if (!PASTE_STOPWORDS.has(match[1])) return normalizeScreenerTicker(match[0]) || null
  }

  const pairMatch = upper.match(/\b([A-Z0-9]{2,15}USDT|[A-Z0-9]{2,15}USD|[A-Z0-9]{2,15}PERP)\b/)
  if (pairMatch?.[1]) {
    const token = pairMatch[1]
    if (token.endsWith('PERP')) return token.slice(0, -4)
    if (token.endsWith('USD') && !token.endsWith('USDT')) return `${token.slice(0, -3)}USDT`
    return token
  }

  const words = upper.match(/\b[A-Z]{2,12}\b/g) || []
  for (const word of words) {
    if (PASTE_STOPWORDS.has(word)) continue
    return word
  }

  return null
}
